module.exports = __webpack_public_path__ + "media/application/images/ui/consumer-trusted-badge-f7db8ddd8b9527faeb186e7018cc8833.png";